import { render, staticRenderFns } from "./RepExample.vue?vue&type=template&id=6baf58fb&scoped=true"
import script from "./RepExample.vue?vue&type=script&lang=js"
export * from "./RepExample.vue?vue&type=script&lang=js"
import style0 from "./RepExample.vue?vue&type=style&index=0&id=6baf58fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf58fb",
  null
  
)

export default component.exports